import { sortBy } from 'lodash';

import { DatasetDimensionMeta } from '../../models/dataset_dimension_meta';
import { TreatmentFactor } from '../../models/treatment';

/**
 * Sort treatment factors in the order of the trial's test subjects.
 *
 * @param factors Factors of one treatment.
 * @param testSubjects Test subjects of the trial, in display order.
 * @returns The factors in test subject order; factors of other dimension types come last.
 */
export function sortFactorsByTestSubjects(
  factors: TreatmentFactor[],
  testSubjects: DatasetDimensionMeta[]
): TreatmentFactor[] {
  const testSubjectDimensionMetaIds = testSubjects.map((testSubject) =>
    String(testSubject.dimensionMeta().id())
  );

  return sortBy(factors, (factor) => {
    const index = testSubjectDimensionMetaIds.indexOf(String(factor.dimension().dimension_meta_id()));
    return index < 0 ? testSubjectDimensionMetaIds.length : index;
  });
}

/**
 * Build the label that lists the dimension elements of a treatment.
 *
 * @param factors Factors of one treatment, in display order.
 * @returns The element names separated by commas, or an empty string without factors.
 */
export function describeTreatmentComposition(factors: TreatmentFactor[]): string {
  return factors.map((factor) => factor.dimension().name()).join(', ');
}
